import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InputSelectComponent } from "@shared/components/input-select/input-select.component";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { SharedModule } from "@shared/shared.module";
import { IconModule } from "../icon/icon.module";

@NgModule({
	declarations: [InputSelectComponent],
	imports: [
		CommonModule,
		MatFormFieldModule,
		MatSelectModule,
		FormsModule,
		ReactiveFormsModule,
		MatTooltipModule,
		SharedModule,
		IconModule
	],
	exports: [InputSelectComponent]
})
export class InputSelectModule {}
